import { handleCall } from '../../helpers/handler';

class BoatModule {
  constructor(httpClientFactory) {
    const boatAPI = httpClientFactory.clients.boat;

    this._store = {
      state: {
        data: {}
      },
      getters: {},
      mutations: {},
      actions: {
        getDuplicates({ state }, params) {
          const { page, limit, category, boat } = params;
          const queryParams = `category=${category}&page=${page}&limit=${limit}`;
          const path = `boats/duplicates/find?${queryParams}`;
          return handleCall('POST', boatAPI, path, boat);
        },
        getProfiles({ state }, params) {
          const { body, category, withCrew = true } = params;
          const path = `boats/duplicates/retrieve?category=${category}&withCrew=${withCrew}`;
          return handleCall('POST', boatAPI, path, body);
        },
        merge({ state }, params) {
          const { id, merge } = params;
          const path = `boats/duplicates/merge?boatId=${id}`;
          return handleCall('POST', boatAPI, path, merge); // merge is the list of IDs
        },
        getBoats({ state }, params) {
          const { page, limit, name } = params || {};
          let queryParams = `page=${page}&limit=${limit}`;
          if (name) {
            queryParams = queryParams.concat(`&name=${name}`);
          }
          const path = `/boats?${queryParams}`;
          return handleCall('GET', boatAPI, path);
        },
        getBoat({ state }, params) {
          const { id } = params;
          const path = `/boats?_id=${id}`;
          return handleCall('GET', boatAPI, path);
        },
        discardBoat({ state }, params) {
          const { id } = params;
          const path = `boats/discard/${id}`;
          return handleCall('GET', boatAPI, path);
        }
      },
      namespaced: true
    };
  }

  get store() {
    return this._store;
  }
}

export default BoatModule;
